import { render, staticRenderFns } from "./unlock.vue?vue&type=template&id=920bb4ba&scoped=true&"
import script from "./unlock.vue?vue&type=script&lang=js&"
export * from "./unlock.vue?vue&type=script&lang=js&"
import style0 from "./unlock.vue?vue&type=style&index=0&id=920bb4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920bb4ba",
  null
  
)

export default component.exports